import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { LegFiJwtService } from '../auth/legfi-jwt.service';
import { Cart } from './cart.model';
import { JwtLegFiClaims } from '../auth/jwt-legfi-claims.model';

@Injectable()
export class CheckoutService
{
    private _http: ApplicationHttpClient;

    constructor(_http: ApplicationHttpClient) {
        this._http = _http;
    }

    /**
     * @param {number} userId
     * @param {Cart} cart
     * @returns {any}
     */
    public memberCheckout(userId: number, cart: Cart): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        return this._http.post(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.UserCheckout(userId || jwt.id),
                ),
                JSON.stringify(cart),
        );
    }

    /**
     * @param {number} orgId
     * @param {Cart} cart
     * @returns {Observable<Object>}
     */
    public organizationCheckout(orgId: number, cart: Cart): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        return this._http.post(
                Routes.MakeLegFiCoreUrl(
                        Routes.LegFiCore.OrganizationCheckout(orgId || jwt.orgId),
                ),
                JSON.stringify(cart),
        );
    }
}
